
import React from "react";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

function TopHeader() {
  return (
    <div
      style={{
        backgroundColor: "#7d5b4b",
        color: "#fff",
        padding: "8px 20px",
        fontSize: "0.95rem",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        fontFamily: "'Noto Sans Devanagari', 'Poppins', sans-serif",
        borderBottom: "2px solid #c8a27e",
      }}
      className="top-header"
    >
      {/* 🌿 Left Quote */}
      <div
        className="top-quote"
        style={{
          fontStyle: "italic",
          flex: "1 1 auto",
          textAlign: "left",
          color: "#f9e5c8",
          fontWeight: "500",
          textShadow: "1px 1px 3px rgba(0,0,0,0.4)",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        “भक्तामर स्तोत्र का प्रत्येक श्लोक आत्मा को शांति और ऊर्जा प्रदान करता है।”
      </div>

      {/* 📞 ✉️ Right Contact Info */}
      <div
        className="top-contact"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          justifyContent: "flex-end",
          flex: "1 1 auto",
          flexWrap: "nowrap",
        }}
      >
        {/* 📞 Phone */}
        <a
          href="tel:+91 91555 99968"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            color: "#ffe6eb",
            textDecoration: "none",
            fontWeight: "500",
            transition: "color 0.3s ease, transform 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = "#ffb6c1";
            e.currentTarget.style.transform = "scale(1.05)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = "#ffe6eb";
            e.currentTarget.style.transform = "scale(1)";
          }}
        >
          <FaPhoneAlt style={{ color: "#ffb6c1", fontSize: "1rem" }} />
          <span>+91 91555 99968</span>
        </a>

        {/* ✉️ Email */}
        <a
          href="mailto:info@jainbhaktamarwalebaba.com"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            color: "#e9dcff",
            textDecoration: "none",
            fontWeight: "500",
            transition: "color 0.3s ease, transform 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = "#d1bfff";
            e.currentTarget.style.transform = "scale(1.05)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = "#e9dcff";
            e.currentTarget.style.transform = "scale(1)";
          }}
        >
          <MdEmail style={{ color: "#e0c3fc", fontSize: "1.1rem" }} />
          <span>info@bhaktamarwalebaba.com</span>
        </a>
      </div>

      {/* 📱 Responsive Styling */}
      <style>
        {`
          @media (max-width: 768px) {
            .top-header {
              flex-direction: column !important;
              text-align: center !important;
              gap: 6px !important;
            }

            .top-quote {
              flex: unset !important;
              white-space: normal !important;
              text-align: center !important;
              margin-bottom: 4px !important;
            }

            .top-contact {
              justify-content: center !important;
              flex-wrap: wrap !important;
              gap: 10px !important;
            }

            .top-contact a {
              font-size: 0.9rem !important;
            }
          }
        `}
      </style>
    </div>
  );
}

export default TopHeader;
